import React, { useState } from 'react';
import {
  Box,
  Button,
  Divider,
  useMediaQuery,
  useTheme,
  Grid
} from '@mui/material';

import { Form, Formik } from 'formik';
import { ExportControlTiempos } from '../../components/reports/controlTiempos/ExportControlTiempos';
import exportControlTiemposFormModel from '../../components/reports/controlTiempos/formModels/exportControlTiemposFormModel';
import formInitialValues from '../../components/reports/controlTiempos/formModels/formInitialValues';
import validationSchema from '../../components/reports/controlTiempos/formModels/validationSchema';
import { useDispatch } from 'react-redux';
import { closeSessionGlobal, hasPemissions } from '../../commons/utils';
import { ModalSessionExpired } from '../../components/generics/ModalSessionExpired';
import MultipleSnackbars from '../../components/MultipleSnackbars';
import { mtDividerUpTable, timeToClosedToast } from '../../commons';
import { SnackAlert } from '../../components/SnackAlert';
import { generateReportControlTime } from '../../store/reports';
import { BreadCrumbsAndTitle } from '../../components/generics/BreadCrumbsAndTitle';
import { AlertsInformativos } from '../../components/generics/AlertsInformativos';
import { alertInformativo } from '../../commons/texts';
import { Downloading } from '@mui/icons-material';
import { AiChat } from '../../components/aiChat/AiChat';
// import esLocale from 'date-fns/locale/es';

export const ReporteControlTiempos = () => {


  // DISPATCH 
  const dispatch = useDispatch();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const [startDate, setStartDate] = useState<Date>(new Date());
  const [endDate, setEndDate] = useState<Date>(new Date());
  const [reportFormat, setReportFormat] = useState<'excel' | 'pdf'>('excel');
  const [reportType, setReportType] = useState({
    excel: true,
    pdf: false
  });

  const [isGenerating, setIsGenerating] = useState(false);
  const [isSubmiting, setIsSubmiting] = React.useState<boolean>(false);
  const [percentaje, setPercentaje] = React.useState(0);
  const [modalSessionExpired, setModalSessionExpired] = React.useState<boolean>(false);
  const [alert_snack, setAlertSnack] = React.useState(false);

  const [timeAlert, setTimeAlert] = React.useState(timeToClosedToast);
  const [messagesAlerts, setMessagesAlerts] = React.useState<any>([]);

  const [msgSnack, setMsgSnack] = React.useState({
      msg: '',
      status: 'success'
  });

  // DATA MODELS 
  const { formId, formField } = exportControlTiemposFormModel;
  const currentValidationSchema = validationSchema[0];




  const _handleSubmit = async(values:any, actions:any) => {
  
       

      // modulo.thumano                             nombre modulo     sub modulo    permission
      const havePermissions = await hasPemissions('modulo.thumano', 'modulo.reportescontroltiempos', 'view');
  
  
      if( !havePermissions ){
  
  
        await validateLsPermissions('No tienes pemisos para (Generar) reporte.');

        return false;
  
          
      }
    
      setIsSubmiting(true);
      setIsGenerating(true);
      actions.setSubmitting(true);
      

      setReportFormat(values.format)
  
      const response = await dispatch( generateReportControlTime(values, setPercentaje) );


      setIsSubmiting(false);
      setIsGenerating(false);
      actions.setSubmitting(false);
     
  
     const result =  await validateResponseCreate(response, ' ( Generar Reporte ) ')


     const url = window.URL.createObjectURL(new Blob([response]));
      
      // Crear enlace temporal
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        `reporte_desde_${new Date(values.from).toISOString().split('T')[0]}_hasta_${new Date(values.to).toISOString().split('T')[0]}.${reportFormat === 'excel' ? 'xlsx' : 'pdf'}`
      );
      
      // Simular click
      document.body.appendChild(link);
      link.click();
      
      // Limpiar
      link.parentNode?.removeChild(link);
      window.URL.revokeObjectURL(url);
  
     if ( response.code == 409) {
         setIsSubmiting(false);
     }
     
  
     if (!result) {
         return false;
     }
  
     setIsSubmiting(false);
  
  
      // if (response.ok) {
  
      //   const errors:any = {
      //     msg: 'Terminal Creada Con Exito',
      //     status: 'success'
      //   };
      
      //   await setMsgSnack(errors);
      //   await setAlertSnack(true);
  
  
      //   actions.setSubmitting(false);
      // }
  
    
  }




    const validateResponseCreate = async(response:any, textActionConcat: string) => {
          
          
        if (  response.code == 401  ) {
          console.log('kupappapap')
          await localStorage.removeItem('lastSelectedQypht');
          await closeSessionGlobal();
          setModalSessionExpired(true);
          return false;
        }
  
      
        // 403 NO TIENE PERMISSO PARA REALIZAR ESA ACCION 
        if (!response.ok && response.code == 403 ) { 
  
        
          const errors:any = {
            msg: response.errors[0]+' '+textActionConcat,
            status: 'error'
          };
        
          await setMsgSnack(errors);
          await setAlertSnack(true);
  
        
          return false;
          
        }
  
  
        // 403 EL DATO YA SE ENCUENTRA REGISTRADO
        if (!response.ok && response.code == 409 ) { 
      
          const errors:any = {
              msg: response.errors[0]+' '+textActionConcat,
              status: 'error'
          };
          
          await setMsgSnack(errors);
          await setAlertSnack(true);
  
          return false;
        }
  
        
        // 400 ERROR EN DATOS ENVIADOS MAYORMENTE PROPIEDAD INVALIDA O MAL FORMATEADO 
        if (!response.ok && response.code == 400 ) { 
  
          const errors:any = [];
  
          response.errors.forEach( (element:any) => {
              
              errors.push({
                type: 'error',
                text: element
              })
          });
  
            
          setMessagesAlerts(errors);
          return false;
  
        }
  
        return true;
      
    } 



   const validateLsPermissions = async(message:string) => {

    const errors:any = {
      msg: message,
      status: 'error'
    };
  
    await setMsgSnack(errors);
    await setAlertSnack(true);
  
  
  }

  return (
    // <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={esLocale}>
    <>



    <BreadCrumbsAndTitle
                  title="Reportes Control Tiempos" 
                  mainModule="Talento humano" 
                  parent="Reportes Control Tiempos"
                  action="" />


    <AlertsInformativos type={'info'} title={'info'} content={alertInformativo.reporteControlTiempos} /> 
    <Divider sx={{ marginBottom: mtDividerUpTable }}/>

      <ModalSessionExpired  open={modalSessionExpired}  />
      <MultipleSnackbars messagesList={messagesAlerts} position={"bottom-left"} autoClose={timeAlert} />
      <SnackAlert open={alert_snack} onclick={setAlertSnack} text={msgSnack.msg} severity={msgSnack.status}/>
   
      <Box sx={{ maxWidth: 800, mx: 'auto', p: 3 }}>
        <Formik 
            initialValues={formInitialValues}
            validationSchema={currentValidationSchema}
            onSubmit={_handleSubmit}>
              <Form id={formId}>
                <ExportControlTiempos formField={formField}/>
                <Grid   size={{ xs: 12 }} >
                  <Button
                  loading={isGenerating}
                  loadingIndicator="Un momento..."
                  variant="contained"
                  color="primary"
                  size="large"
                  startIcon={<Downloading />}
                  type='submit'
                  fullWidth
                  sx={{
                      marginTop: 3,
                      py: 1.5,
                      borderRadius: 1,
                      fontWeight: 'bold',
                      boxShadow: 'none',
                      '&:hover': {
                      boxShadow: 'none',
                      backgroundColor: theme.palette.primary.dark
                      }
                  }}
                  >
                  {isGenerating ? 'Generando...' : 'Descargar Reporte'}
                  </Button>
              </Grid>
              </Form>
        </Formik>
        
      </Box>
      <AiChat />
    </>
    // </LocalizationProvider>
  );
};

